// extracted by mini-css-extract-plugin
export default {"add_edge_back_view_content":"AddEdgeBackView_add_edge_back_view_content__WmkZk"};